import { useCallback, useEffect, useState } from "react";

export type Route = { name: "chat" } | { name: "detail"; id: string };

function read(): Route {
  const match = location.pathname.match(/^\/listing\/([\w-]+)\/?$/);
  return match ? { name: "detail", id: match[1] } : { name: "chat" };
}

/**
 * Two routes, no router dependency. Real URLs so a listing can be shared or
 * opened in a new tab, but navigation stays client-side so the conversation
 * survives a trip to a listing and back.
 */
export function useRoute() {
  const [route, setRoute] = useState<Route>(read);

  useEffect(() => {
    const onPop = () => setRoute(read());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback((path: string) => {
    if (path !== location.pathname) history.pushState({}, "", path);
    setRoute(read());
  }, []);

  return { route, navigate };
}
